export default __webpack_public_path__ + "static/media/pic2.df9921d1.jpg";